// extracted by mini-css-extract-plugin
export default {"yearTableContainer":"GodisnjaTabela_yearTableContainer__Ez03q","spinner":"GodisnjaTabela_spinner__zmKdY"};